import { useEffect, useState } from 'react';
import { useRequest } from 'use-react-api-request';
import { previewSystemPrompt } from '../../../api';
import { notify } from '../../../app';

export const usePromptPreview = (initialContent: string) => {
  const [previewPrompt, setPreviewPrompt] = useState<string | null>(null);
  const [isPreviewMode, setIsPreviewMode] = useState(false);
  const [currentContent, setCurrentContent] = useState(initialContent);

  const [handlePreviewPrompt, previewingPrompt] = useRequest(
    async (_signal, payload: string) => await previewSystemPrompt(payload),
    {
      onSuccess: preview => {
        setPreviewPrompt(preview);
      },
      onError: () => {
        notify.error('Failed to preview the prompt');
      },
      deps: [],
    }
  );

  useEffect(() => {
    setCurrentContent(initialContent);
  }, [initialContent]);

  return {
    handlePreviewPrompt,
    previewingPrompt,
    previewPrompt,
    setPreviewPrompt,
    isPreviewMode,
    setIsPreviewMode,
    currentContent,
    setCurrentContent,
  };
};
